module.exports = __webpack_public_path__ + "img/mediamarkt.93e59a13.png";